(() => {
  document.addEventListener('click', (e) => {
    const button = e.target.closest(
      'button.cart__checkout-button, button#cart-notification-checkout'
    );

    if (
      button &&
      window.hulkapps != null &&
      window.is_draft_order === true &&
      typeof window.hulkappsCheckout === 'function'
    ) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      window.hulkappsCheckout();
    }
  }, true);
})();
